// extracted by mini-css-extract-plugin
export default {"question":"r_AZa9","md":"aDREs6","label":"Uji4Py","xs":"u_uPbP","option":"kcK87C","sm":"hXlh5N","options-container":"Al5vhu","optionsContainer":"Al5vhu","options":"ptlAvb"};